import React from 'react';
import { Box } from '@mui/material';
import { Bone, FrameworkColumnsSkeleton, TierPanelSkeleton } from '../../../../../components/ui/DashboardSkeletons';
import { useIsMobileApp } from '../../../../../mobile/mobileApp';

/**
 * My Learning Pathway body while it loads: the Your Learning Tier panel on the
 * left and the four pillar columns on the right, in the same frames the real
 * page uses, so the content fades in place instead of replacing a spinner.
 */
const MemberPathwaySkeleton: React.FC = () => {
  const isMobileApp = useIsMobileApp();
  // Phone: the one-column list, a section header over full-width rows.
  if (isMobileApp) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <Bone width="100%" height={44} />
        <Bone width="38%" height={20} />
        {[0, 1, 2, 3].map((i) => (
          <Bone key={i} width="100%" height={78} />
        ))}
      </Box>
    );
  }
  return (
    <Box sx={{ flex: 1, minHeight: 0, pb: 3, display: 'flex', flexDirection: 'row' }}>
      <Box
        sx={{
          flex: '0 0 30%',
          minWidth: 300,
          height: '100%',
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          p: '12px',
          mr: '8px',
          gap: '10px',
          bgcolor: '#1C1C1C',
          border: '1px solid rgba(247, 148, 32, 0.45)',
          borderRadius: '8px'
        }}
      >
        <Bone width="55%" height={22} />
        <TierPanelSkeleton />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0, height: '100%', display: 'flex' }}>
        <FrameworkColumnsSkeleton cardHeight={150} />
      </Box>
    </Box>
  );
};

export default MemberPathwaySkeleton;
